let tpl = require('./customfields.tpl.html');

class CustomFieldsController{
    constructor($equalOneUIService, $customFieldsService, $scope, $translate) {
        this.$equalOneUIService = $equalOneUIService;
        this.$translate = $translate;

        this.customFields = $customFieldsService.customfields;
        for(var i in this.customFields) {
            let key = "custominfos.field."+this.customFields[i].key;
            let trans = this.$translate.instant(key);
            this.customFields[i].nameTranslation = (trans == key ? this.customFields[i].name : trans);

            key = "custominfos.field."+this.customFields[i].key+".helper";
            trans = this.$translate.instant(key);
            this.customFields[i].helperTranslation = (trans == key ? this.customFields[i].helper : trans);

            key = "custominfos.field."+this.customFields[i].key+".placeholder";
            trans = this.$translate.instant(key);console.log(this.customFields[i].placeholder);
            this.customFields[i].placeholderTranslation = (trans == key ? this.customFields[i].placeholder : trans);
        }

        this.fields = $customFieldsService.fields;
        this.nbCustomFieldsSet = 0;
        this.$scope = $scope;

        this.enabled = $equalOneUIService.enabled;

        $scope.$watch(() => this.fields, (newValue) => {
            $customFieldsService.save(this.fields);
            this.fields = $customFieldsService.fields;
            this.nbCustomFieldsSet = Object.keys(this.fields).length;
        }, true);
    }
}

CustomFieldsController.$inject = ['EQualOneUIService', 'CustomFieldsService', '$scope', '$translate'];

let CustomFields = {
    bindings: {},
    templateUrl: tpl,
    controller: CustomFieldsController
};

export default CustomFields;


// WEBPACK FOOTER //
// ./src/equalone-ui/components/customfields/customfields.component.js